import { Progressable } from '../../Foundation';
import domready from 'domready';

export class PageLoading { 
    constructor (el) {
        this._refs = {
            el: el
        };

        // Checking if page has loaded
        if (document.readyState === 'complete') {
            this._pageHasLoaded();
        } else {
            domready(() => this._pageHasLoaded());
        }

        // Add page load
        this.pageLoad = new Progressable();
        this.pageLoad.show();
    }

    _pageHasLoaded () {
        // Remove page load
        this.pageLoad._remove();
    }
}